import { Box } from '@mui/material';
import Holdings from '../../component/pools/Holdings';
import PoolHistory from '@/component/pools/PoolHistory';

import CommonTop from '@/component/pools/CommonTop';

export default function PortfolioMain() {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', md: '0px' },
        }}
      >
        {/* Pools Title Section */}
        <CommonTop title="Portfolio" subtitle="Track And Manage Your Portfolio">
          <Box
            sx={{
              padding: '16px 24px',
              maxWidth: { xs: '1920px', md: '352px' },
            }}
          >
            {/* <PoolsOverview title="Total Staked Value" content="0 USD" /> */}
          </Box>
        </CommonTop>
        {/* Holdings */}
        {<Holdings />}
        {/* Transaction History */}
        {<PoolHistory />}
      </Box>
    </>
  );
}
